"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseExpression = void 0;

var uuid_1 = require("./support/uuid");

;
;
;

function parseFormat(e) {
  var e_1, _a;

  e = e.trim();

  if (e.length > 2 && e[0] === "[" && e[e.length - 1] === "]") {
    var formatInner = e.slice(1, e.length - 1);
    var formatParts = [];
    var lastSplitEnd = 0;
    var malformed = false;

    for (var i = 0; i < formatInner.length; i++) {
      if (formatInner[i] === "{" || formatInner[i] === "}") {
        malformed = true;
        break;
      }

      if (formatInner[i] === ",") {
        formatParts.push(formatInner.substr(lastSplitEnd, i - lastSplitEnd));
        lastSplitEnd = i + 1;
      }
    }

    if (!malformed) {
      formatParts.push(formatInner.substr(lastSplitEnd));
    }

    var label = undefined;
    var unit = undefined;
    var color = undefined;
    var format = {};

    try {
      for (var formatParts_1 = __values(formatParts), formatParts_1_1 = formatParts_1.next(); !formatParts_1_1.done; formatParts_1_1 = formatParts_1.next()) {
        var selectorPart = formatParts_1_1.value;
        var p = selectorPart.trim();
        var labelSplit = p.split("label=");
        var unitSplit = p.split("unit=");
        var colorSplit = p.split("color=");

        if (labelSplit.length > 1) {
          if (labelSplit[1][0] === '"') {
            label = labelSplit[1].slice(1, labelSplit[1].length - 1);
          } else {
            label = labelSplit[1];
          }
        } else if (unitSplit.length > 1) {
          if (unitSplit[1][0] === '"') {
            unit = unitSplit[1].slice(1, unitSplit[1].length - 1);
          } else {
            unit = unitSplit[1];
          }
        } else if (colorSplit.length > 1) {
          if (colorSplit[1][0] === '"') {
            color = colorSplit[1].slice(1, colorSplit[1].length - 1);
          } else {
            color = colorSplit[1];
          }
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (formatParts_1_1 && !formatParts_1_1.done && (_a = formatParts_1.return)) _a.call(formatParts_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    if (label != undefined) {
      format.label = label;
    }

    if (unit != undefined) {
      format.unit = unit;
    }

    if (color != undefined) {
      format.color = color;
    }

    if (label != undefined || unit != undefined || color != undefined) {
      return format;
    }
  }

  return;
}

function parseAttributes(e) {
  var e_2, _a;

  e = e.trim();

  if (e.length > 2 && e[0] === "[" && e[e.length - 1] === "]") {
    var attr = {};
    var hasAttr = false;
    var formatInner = e.slice(1, e.length - 1);
    var formatParts = [];
    var lastSplitEnd = 0;
    var malformed = false;

    for (var i = 0; i < formatInner.length; i++) {
      if (formatInner[i] === "{" || formatInner[i] === "}") {
        malformed = true;
        break;
      }

      if (formatInner[i] === ",") {
        formatParts.push(formatInner.substr(lastSplitEnd, i - lastSplitEnd));
        lastSplitEnd = i + 1;
      }
    }

    if (!malformed) {
      formatParts.push(formatInner.substr(lastSplitEnd));
    }

    try {
      for (var formatParts_2 = __values(formatParts), formatParts_2_1 = formatParts_2.next(); !formatParts_2_1.done; formatParts_2_1 = formatParts_2.next()) {
        var selectorPart = formatParts_2_1.value;
        var p = selectorPart.trim();
        var eqSplit = p.split("=");
        var key = "";
        var value = "";

        if (eqSplit.length > 1) {
          key = eqSplit[0];

          if (eqSplit[1][0] === '"') {
            value = eqSplit[1].slice(1, eqSplit[1].length - 1);
          } else {
            value = eqSplit[1];
          }
        }

        if (key !== "" && value !== "") {
          attr[key] = value;
          hasAttr = true;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (formatParts_2_1 && !formatParts_2_1.done && (_a = formatParts_2.return)) _a.call(formatParts_2);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    if (hasAttr) {
      return attr;
    }
  }

  return;
}

function parseSelector(e) {
  var e_3, _a;

  e = e.trim();

  if (e.length > 2 && e[0] === "{" && e[e.length - 1] === "}") {
    // could be a selector
    var selectorInner = e.slice(1, e.length - 1);
    var selectorParts = [];
    var lastSplitEnd = 0;
    var malformed = false;

    for (var i = 0; i < selectorInner.length; i++) {
      if (selectorInner[i] === "{" || selectorInner[i] === "}") {
        malformed = true;
        break;
      }

      if (selectorInner[i] === ",") {
        selectorParts.push(selectorInner.substr(lastSplitEnd, i - lastSplitEnd));
        lastSplitEnd = i + 1;
      }
    }

    if (!malformed) {
      selectorParts.push(selectorInner.substr(lastSplitEnd));
    }

    var id = 0;
    var index = "";
    var unit = ""; //let uri = new Lwm2mURI();

    var uuid = uuid_1.EmptyUUID();
    var assetID = "";
    var tag = "";

    try {
      for (var selectorParts_1 = __values(selectorParts), selectorParts_1_1 = selectorParts_1.next(); !selectorParts_1_1.done; selectorParts_1_1 = selectorParts_1.next()) {
        var selectorPart = selectorParts_1_1.value;
        var p = selectorPart.trim();
        var uuidSplit = p.split("uuid=");
        var assetIDSplit = p.split("assetid=");
        var tagSplit = p.split("tag=");
        var idSplit = p.split("id=");
        var indexSplit = p.split("index=");
        var uriSplit = p.split("uri=");
        var unitSplit = p.split("unit=");

        if (uuidSplit.length > 1) {
          if (uuidSplit[1][0] === '"') {
            uuid = new uuid_1.UUID(uuidSplit[1].slice(1, uuidSplit[1].length - 1));
          } else {
            uuid = new uuid_1.UUID(uuidSplit[1]);
          }
        } else if (assetIDSplit.length > 1) {
          if (assetIDSplit[1][0] === '"') {
            assetID = assetIDSplit[1].slice(1, assetIDSplit[1].length - 1);
          } else {
            assetID = assetIDSplit[1];
          }
        } else if (tagSplit.length > 1) {
          if (tagSplit[1][0] === '"') {
            tag = tagSplit[1].slice(1, tagSplit[1].length - 1);
          } else {
            tag = tagSplit[1];
          }
        } else if (idSplit.length > 1) {
          if (idSplit[1][0] === '"') {
            id = parseInt(idSplit[1].slice(1, idSplit[1].length - 1));
          } else {
            id = parseInt(idSplit[1]);
          }
        } else if (indexSplit.length > 1) {
          if (indexSplit[1][0] === '"') {
            index = indexSplit[1].slice(1, indexSplit[1].length - 1);
          } else {
            index = indexSplit[1];
          }
        } else if (unitSplit.length > 1) {
          if (unitSplit[1][0] === '"') {
            unit = unitSplit[1].slice(1, unitSplit[1].length - 1);
          } else {
            unit = unitSplit[1];
          }
        } else if (uriSplit.length > 1) {
          console.log("has uri");
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (selectorParts_1_1 && !selectorParts_1_1.done && (_a = selectorParts_1.return)) _a.call(selectorParts_1);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    if (id > 0) {
      if (assetID.length > 0) {
        return {
          uuid: uuid,
          assetID: assetID,
          id: id
        };
      }

      if (tag.length > 0) {
        return {
          uuid: uuid,
          tag: tag,
          id: id
        };
      }

      return {
        uuid: uuid,
        id: id
      };
    }

    if (index.length > 0) {
      if (assetID.length > 0) {
        return {
          uuid: uuid,
          assetID: assetID,
          index: index
        };
      }

      if (tag.length > 0) {
        return {
          uuid: uuid,
          tag: tag,
          index: index
        };
      }

      return {
        uuid: uuid,
        index: index
      };
    }

    if (unit.length > 0) {
      if (assetID.length > 0) {
        return {
          uuid: uuid,
          assetID: assetID,
          unit: unit
        };
      }

      if (tag.length > 0) {
        return {
          uuid: uuid,
          tag: tag,
          unit: unit
        };
      }

      return {
        uuid: uuid,
        unit: unit
      };
    }
  }

  return;
}

function parseConstant(e) {
  e = e.trim();

  if (!isNaN(parseFloat(e))) {
    return {
      value: parseFloat(e)
    };
  }

  return;
}

function extractFormatAndAttributes(e) {
  e = e.trim();
  var ret = [undefined, undefined, e];

  if (e[0] === "[") {
    var hardBracketContent = e.slice(0, e.indexOf("]") + 1);
    var hardBracketRest = e.slice(e.indexOf("]") + 1);
    var fmt = parseFormat(hardBracketContent);
    var attr = parseAttributes(hardBracketContent);

    if (fmt != null) {
      ret[0] = fmt;
      ret[2] = hardBracketRest;
    }

    if (attr != null) {
      ret[1] = attr;
      ret[2] = hardBracketRest;
    }
  }

  return ret;
}

function extractTransform(e, transform, domain) {
  e = e.trim();

  if (e.startsWith(transform)) {
    var subExpression = e.substr(transform.length);

    if (transform.endsWith("time")) {
      transform = transform.slice(0, -4);
    } // remove the time suffix


    var formatRes = extractFormatAndAttributes(subExpression);
    subExpression = formatRes[2];

    if (subExpression.length > 2 && subExpression[0] === "(" && subExpression[subExpression.length - 1] === ")") {
      return [{
        operation: transform,
        domain: domain
      }, formatRes[0], formatRes[1], subExpression.slice(1, subExpression.length - 1)];
    }
  }

  return [undefined, undefined, undefined, e];
}

function extractAnyTransform(e) {
  e = e.trim();
  var transformKeys = ["delta", "avg", "sum", "min", "max", "add", "sub", "mul", "div", "gt", "lt", "eq", "mod", "persecond", "perhour", "perday", "avgtime", "mintime", "maxtime", "abs", "towh", "toWh", "tokwh", "tokWh", "tomwh", "toMWh", "tow", "toW", "tokw", "tokW", "tomw", "toMW", "tom3", "tol", "interpolate", "locf", ""];
  var transformDomains = ["time", "space", "time", "space", "space", "space", "space", "space", "space", "space", "space", "space", "space", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time", "time"];

  for (var i = 0; i < transformKeys.length; i++) {
    var _a = __read(extractTransform(e, transformKeys[i], transformDomains[i]), 4),
        transform = _a[0],
        format = _a[1],
        attributes = _a[2],
        ee = _a[3];

    if (transform !== undefined) {
      return [transform, format, attributes, ee];
    }
  }

  return [undefined, undefined, undefined, e];
}

function splitParse(e) {
  var ret = [];
  var inSelector = 0;
  var inTransform = 0;
  var inFormat = 0;
  var lastSplitEnd = 0;

  for (var i = 0; i < e.length; i++) {
    if (e[i] === "{") {
      inSelector++;
    }

    if (e[i] === "}") {
      inSelector--;
    }

    if (e[i] === "(") {
      inTransform++;
    }

    if (e[i] === ")") {
      inTransform--;
    }

    if (e[i] === "[") {
      inFormat++;
    }

    if (e[i] === "]") {
      inFormat--;
    }

    if (inSelector === 0 && inTransform === 0 && inFormat === 0) {
      if (e[i] === ",") {
        // split
        ret.push(e.substr(lastSplitEnd, i - lastSplitEnd));
        lastSplitEnd = i + 1;
      }
    }
  }

  ret.push(e.substr(lastSplitEnd));
  return ret;
}

function recursiveParseExpression(e) {
  // remove something from e and call this again
  var transform = {
    operation: "none",
    domain: "time"
  };
  var attributes = undefined;
  var split = splitParse(e);

  if (split.length == 1) {
    var constant = parseConstant(e);

    if (constant != null) {
      return {
        transform: transform,
        expression: [constant]
      };
    }

    var selector = parseSelector(e);

    if (selector != null) {
      return {
        transform: transform,
        expression: [selector]
      };
    }

    var _a = __read(extractAnyTransform(e), 4),
        extractedTransform = _a[0],
        format = _a[1],
        attr = _a[2],
        remainingE = _a[3];

    if (extractedTransform != null) {
      transform = extractedTransform;
    }

    attributes = attr;
    split = splitParse(remainingE); // this is needed to ensure we dont recurse to do moon

    if (remainingE.length === e.length && split.length === 1) {
      throw "recursiveParseExpression failed to parse: " + e + "==" + remainingE;
    }

    var expression_1 = split.map(function (part) {
      return recursiveParseExpression(part);
    });

    if (format != null) {
      return {
        transform: transform,
        format: format,
        attributes: attributes,
        expression: expression_1
      };
    }

    return {
      transform: transform,
      attributes: attributes,
      expression: expression_1
    };
  }

  var expression = split.map(function (part) {
    return recursiveParseExpression(part);
  });
  return {
    transform: transform,
    expression: expression
  };
}

function parseExpression(e) {
  // min(delta({index="/10243/0/18", uuid="7ba5203c-df57-43e2-8685-c081309d49d9"}))
  // delta({index="/10243/0/18", uuid="7ba5203c-df57-43e2-8685-c081309d49d9"}) - delta({index="/10243/0/28", uuid="7ba5203c-df57-43e2-8685-c081309d49d9"})
  return recursiveParseExpression(e);
}

exports.parseExpression = parseExpression;
/** We want to create a language for creating data requests in a more user friendly format.
 *  Rough syntax:
 *   - Selectors: {uri="asdasd", uuid="asdasd"}
 *   - Constants: 3
 *   - Expressions: avg(x), perhaps: +/-/* and /
 *   - Wrappers ()
 */

/*
 interface Help {
   name: string,
   operator?: string,
   description: string,
   example: string,
 }



 const Selector: Help = {
   name: "Selector",
   description: 'A selector describes what data to access. \
    It is identified with "curly brackets" and one or more of the following keywords: id=, index=, uri= and uuid=. \
    Where id is the exact resource ID to be used, index is a complete identifier of the resource, uri is a partial index and \
    uuid limits selection to a subtree from and including the uuid',
   example: '{index=/10243/0/18/0, uuid=e066bc15-abb4-43ac-bbf8-bdbb55708f69}'
 };

 const Constant: Help = {
   name: "Constant",
   description: 'A single value constant which can be used to perform calculations, e.g. in combination with operators',
   example: '1000'
 };

 const Operator: Help = {
   name: "Minimum",
   operator: "min",
   description: "min returns the smallest value",
   example: "min({index=/10243/0/18/0, uuid=e066bc15-abb4-43ac-bbf8-bdbb55708f69})"
 }
*/